import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bento from "@/components/Bento";
import ParallaxLayer from "@/components/ParallaxLayer";
import { useLang } from "@/App";

const EDGE_ART = [
    {
        img: "https://images.unsplash.com/photo-1761083261633-5aa782b6ddfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxjeWJlcnB1bmslMjBhbmltZSUyMGNoYXJhY3RlciUyMG5lb24lMjBuaWdodCUyMHBvcnRyYWl0fGVufDB8fHx8MTc5Mjk2MDE1N3ww&ixlib=rb-4.1.0&q=85",
        pos: "left-[-60px] top-[92vh]",
        w: 300,
        h: 460,
        bleed: "char-bleed-r",
        op: "opacity-[0.07] lg:opacity-[0.1]",
        speed: -70,
    },
    {
        img: "https://images.unsplash.com/photo-1780702335071-06e6e65ba5f8?q=80&w=700&auto=format&fit=crop",
        pos: "right-[-50px] top-[148vh]",
        w: 280,
        h: 430,
        bleed: "char-bleed",
        op: "opacity-[0.06] lg:opacity-[0.09]",
        speed: 90,
    },
    {
        img: "https://images.unsplash.com/flagged/photo-1579451443170-44b3963c3341?q=80&w=700&auto=format&fit=crop",
        pos: "left-[-70px] top-[208vh]",
        w: 300,
        h: 440,
        bleed: "char-bleed-r",
        op: "opacity-[0.06] lg:opacity-[0.08]",
        speed: -100,
    },
    {
        img: "https://images.unsplash.com/photo-1620215175664-cb9a6f5b6103?q=80&w=700&auto=format&fit=crop",
        pos: "right-[-65px] top-[262vh]",
        w: 300,
        h: 450,
        bleed: "char-bleed",
        op: "opacity-[0.08] lg:opacity-[0.12]",
        speed: 75,
        label: { ua: "МАЙН // SOLO", en: "MAINE // SOLO" },
        testid: "edge-art-maine",
    },
];

export default function HomePage() {
    const { lang } = useLang();
    return (
        <div className="relative overflow-hidden">
            {EDGE_ART.map((a, i) => (
                <ParallaxLayer
                    key={i}
                    speed={a.speed}
                    testid={a.testid || `edge-art-${i}`}
                    className={`absolute ${a.pos} ${a.bleed} ${a.op} bg-cover bg-center pointer-events-none z-0`}
                    style={{ backgroundImage: `url(${a.img})`, width: a.w, height: a.h }}
                >
                    {a.label && (
                        <div className="absolute bottom-3 left-3 bg-[#080a12]/85 backdrop-blur border border-[#d7ff35]/50 px-2 py-1 font-mono2 text-[8px] tracking-[0.25em] text-[#d7ff35]">
                            {lang === "ua" ? a.label.ua : a.label.en}
                            <span className="kana block text-[9px] text-[#d7ff35]/70 mt-0.5 tracking-[0.3em]">メイン</span>
                        </div>
                    )}
                </ParallaxLayer>
            ))}
            <Hero />
            <Marquee />
            <Bento />
        </div>
    );
}
